import React, { useEffect, useState } from "react"
import IntrestedCandidatesApi from "../../Api/IntrestedCandidatesApi"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import "./IntrestedCandidates.scss"

const IntrestedCandidates = () => {
  document.title = "Interested Candidates"
  const [intrestedCandidates, setIntrestedCandidates] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Candidates", link: "#" },
    { label: "Interested Candidates", link: "#" },
  ]

  useEffect(() => {
    IntrestedCandidatesApi.getAllIntrestedCandidates()
      .then((response) => {
        // Check if response.data.informationFormData exists and is an array
        if (response.data && Array.isArray(response.data.informationFormData)) {
          setIntrestedCandidates(response.data.informationFormData)
          setTotalRecords(response.data.informationFormData.length)
        } else {
          // If the data structure is different, log it for debugging
          console.log("API Response:", response.data)
          setIntrestedCandidates([])
          setTotalRecords(0)
        }
        setLoading(false)
      })
      .catch((error) => {
        console.error("Error fetching data:", error)
        setLoading(false)
        setIntrestedCandidates([])
      })
  }, [page, limit])

  // Function to format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString()
  }

  const totalPages = Math.ceil(totalRecords / limit)

  return (
    <div className="interested-candidates">
      <Row>
        <Col xs="12">
          <div className="list-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Interested Candidates" />
          </div>

          <div className="data-table table-responsive mt-4 mb-3">
            {loading ? (
              <DataTableLoader cols={6} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>City</th>
                    <th>Comment</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(intrestedCandidates) && intrestedCandidates.map((candidate, index) => (
                    <tr key={candidate._id}>
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{candidate.name}</td>
                      <td>{candidate.email}</td>
                      <td>{candidate.phone}</td>
                      <td>{candidate.city}</td>
                      <td>{candidate.comment}</td>
                      <td>{formatDate(candidate.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>

          {totalPages > 1 && (
            <div className="pagination-container d-flex align-items-center justify-content-end">
              <Pagination>
                <PaginationItem disabled={page <= 1}>
                  <PaginationLink previous onClick={() => setPage(page - 1)} />
                </PaginationItem>
                {[...Array(Math.min(3, totalPages))].map((_, index) => (
                  <PaginationItem key={index} active={index + 1 === page}>
                    <PaginationLink onClick={() => setPage(index + 1)}>
                      {index + 1}
                    </PaginationLink>
                  </PaginationItem>
                ))}
                {totalPages > 3 && <PaginationItem disabled>
                  <PaginationLink>...</PaginationLink>
                </PaginationItem>}
                <PaginationItem disabled={page >= totalPages}>
                  <PaginationLink next onClick={() => setPage(page + 1)} />
                </PaginationItem>
              </Pagination>
            </div>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default IntrestedCandidates

